<template>
  <div class="monitor_wrap">
    <div class="mainHead">
      <div class="route">
        <span class="crumbs"></span><span class="router_link" @click="linkIndex">报警审核</span><span class="arrow">></span><span class="router_link" @click="linkDetail">报警详情</span><span class="arrow">></span><span>退回成功</span>
      </div>
      <div>
        <el-button type="primary" @click="returnBtn">返回</el-button>
      </div>
    </div>
    <div class="main clearfix">
        <div>
          <p class="tip_size"><img src="../../../src/assets/img/exit_success.png" alt="">{{title}}</p>
          <p class="tip_time">（{{basicTime}}）秒后自动返回报警详情</p>
        </div>
      <div class="result_btn"><el-button type="primary" @click="returnBtn">返回报警审核页面</el-button></div>
    </div>
  </div>
</template>

<style scoped>
  .main{
      padding-top: 145px;
      background: #fff;
      /*height: 100%;*/
      text-align: center;
  }
  .router_link:hover{
    color: #198cff;
    cursor: pointer;
  }
  .monitor_wrap{
    height: 100%;
    background: #fff;
  }
  .result_btn button{
    width: 200px;
    height: 40px;
    font-size: 16px;
  }
  .tip_time{
    color: #282828;
    padding: 20px 0 30px;
  }
  .tip_size{
    font-size: 28px;
    color: #282828;
    font-weight: bold;
  }
  .tip_size img{
    width: 36px;
    height: 36px;
    vertical-align: middle;
    margin-right: 10px;
  }
</style>

<script>
  export default {
    name:'exitSuccess',
    component:'',
    data(){
      return{
        title:'',
        widthNum: '',   //中间区域自适应宽度
        widthCard: '', //计算卡片宽度
        widthText: '', //计算卡片文本宽度
        total:0,
        monitorList:[],
        basicTime:6,
        timer:null,
      }
    },
    created() {
        if(this.$route.query.type==='2'){
         this.title = '上报成功';
        }else{
          this.title = '退回成功';
        }
        this.getTime();
    },
    computed:{

    },
    methods:{
      linkIndex(){
        this.$router.push({path:'/content/indexExamine'})
      },
      linkDetail(){
        this.$router.push({path:'/content/warnExamine'})
      },
      returnBtn(){ //返回按钮;
        this.$router.push({path:'/content/warnExamine'}); //报警处理
      },
      handleCurrentChange(){

      },
      getTime(){
        let _this=this;
        _this.basicTime=_this.basicTime-1;
        if(_this.basicTime==0){
          _this.$router.push({path:'/content/warnExamine'});
        }
        this.timer=setTimeout(function () {
          _this.getTime();
        },1000);
      },
    },
    mounted(){

    },
    destroyed(){
      if(this.timer){
        clearTimeout(this.timer)
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/page/warningManger/exitSuccess.vue